// @flow
import { httpClient } from 'angieslist-app-platform';

export type InboxPageHtml = {
  html: string,
};

export type AutomationTemplate = {
  id: number,
  text: string,
  title: string,
};

const getInboxHtml = (serviceProviderId: string, conversationId: string, userId: string, isLeadPro: boolean, leadId: string, email: string): Promise<{ body: InboxPageHtml }> => httpClient.post(`/content/inbox/inbox${conversationId ? `/${conversationId}` : ''}${userId ? `?userId=${userId}` : ''}${leadId ? `&leadId=${leadId}` : ''}`, {
  body: JSON.stringify({
    entityId: `${isLeadPro ? '' : 'al_'}${serviceProviderId}`,
    siteBrandKey: isLeadPro ? 'OfficeAppLeads' : 'OfficeApp',
    emailAddress: email,
  }),
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'POST',
    'Access-Control-Allow-Headers': 'Content-Type',
    'site-brand-key': isLeadPro ? 'OfficeAppLeads' : 'OfficeApp',
  },
});

const getAutomationMessage = (serviceProviderId: string): Promise<{ text: string }> => httpClient.get(`/gateway/message-center/v2/automatedMessage/${serviceProviderId}?serviceProviderId=${serviceProviderId}&leadType=ads`, {
  headers: {
    'X-ANGI-CallerId': serviceProviderId,
  },
});

const setAutomationMessage = (serviceProviderId: string, text: string): Promise<any> => httpClient.post('/gateway/message-center/v2/automatedMessage', {
  body: {
    serviceProviderId: Number(serviceProviderId),
    leadType: 'ads',
    text,
  },
  headers: {
    'X-ANGI-CallerId': serviceProviderId,
  },
});

const getAutomationTemplates = (serviceProviderId: string): Promise<{ templates: AutomationTemplate[] }> => httpClient.get('/gateway/message-center/v1/automatedMessageTemplates?leadType=ads&messageTypeId=1', {
  headers: {
    'X-ANGI-CallerId': serviceProviderId,
  },
});

type UnreadCountResponse = { body?: { unreadCount?: number }, unreadCount?: number };

function normalizeUnreadCount(response: UnreadCountResponse): number {
  if (response.body && response.body.unreadCount != null) {
    return response.body.unreadCount;
  }
  if (response.unreadCount != null) {
    return response.unreadCount;
  }
  return 0;
}

const serviceProvidersUnreadPath = (spId: string) =>
  `/gateway/message-center/v1/service-providers/${spId}/unread-count`;

const getUnreadMessageCountFromConversationService = (serviceProviderId: string) => httpClient
  .get(serviceProvidersUnreadPath(serviceProviderId), {
    headers: { 'X-ANGI-CallerId': serviceProviderId },
  })
  .then(response => ({ body: { unreadCount: normalizeUnreadCount(response) } }));

const getUnreadMessageCountFromCat = (serviceProviderId: string, email: string): Promise<{ body: { unreadCount: number } }> => httpClient.post(`/gateway/message-center/v1/cat/unreadCountForLeads/${serviceProviderId}`, {
  body: {
    email,
  },
  headers: {
    'Content-Type': 'application/json',
    'X-ANGI-CallerId': serviceProviderId,
  },
});

const getUnreadMessageCount = (
  serviceProviderId: string,
  email: string,
  useNewApi?: boolean,
): Promise<{ body: { unreadCount: number } }> => {
  if (useNewApi === true) {
    return getUnreadMessageCountFromConversationService(serviceProviderId);
  }
  return getUnreadMessageCountFromCat(serviceProviderId, email);
};

export default {
  getInboxHtml,
  getAutomationMessage,
  getAutomationTemplates,
  setAutomationMessage,
  getUnreadMessageCount,
};



// WEBPACK FOOTER //
// ./src/modules/inbox/common/inboxService.js